module.exports = __webpack_public_path__ + "img/bill-5.ba6960ea.png";